import { render } from "./FaqAccordion.vue?vue&type=template&id=7515481e&scoped=true"
import script from "./FaqAccordion.vue?vue&type=script&lang=js"
export * from "./FaqAccordion.vue?vue&type=script&lang=js"

import "./FaqAccordion.vue?vue&type=style&index=0&id=7515481e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7515481e"

export default script